import { render, staticRenderFns } from "./exhibition-scan.vue?vue&type=template&id=2a45745f&scoped=true&"
import script from "./exhibition-scan.vue?vue&type=script&lang=js&"
export * from "./exhibition-scan.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-scan.vue?vue&type=style&index=0&id=2a45745f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45745f",
  null
  
)

export default component.exports